<form #detailsForm="ngForm" *ngIf="card">
    <div class="modal-header">
        <button type="button" class="close" (click)="cancel()"><span aria-hidden="true">×</span></button>
        <h4 class="modal-title">{{ isNew ? 'New Card' : card.CardName }}</h4>
        <div class="margin-top-5" *ngIf="card && card.CardStatus">
            <span
                class="label"
                [ngClass]="{
                    'label-danger': card.CardStatus === 'Expired',
                    'label-warning': card.CardStatus === 'Expiring',
                    'label-success': card.CardStatus === 'Valid',
                }"
                >{{ card.CardStatus }}</span
            >
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-xs-8">
                <div class="form-group">
                    <label><span class="mandatory-field"></span>Card Type </label>
                    <select legacy-css name="CardType" class="form-control" [(ngModel)]="card.CardType" required>
                        <option value="">Select Type</option>
                        <option *ngFor="let type of cardTypes" [value]="type">{{ type }}</option>
                    </select>
                </div>
            </div>
            <div class="col-xs-4">
                <div class="form-group">
                    <label><span class="mandatory-field"></span>Expiry </label>
                    <div class="input-group">
                        <input
                            legacy-css
                            bsDatepicker
                            [bsConfig]="{
                                adaptivePosition: true,
                                showWeekNumbers: false,
                                containerClass: 'theme-default',
                                customTodayClass: 'bsdatepicker-today',
                                dateInputFormat: locale,
                            }"
                            autocomplete="off"
                            type="text"
                            class="form-control form-control-v2"
                            [(ngModel)]="dt"
                            id="expiryDate"
                            name="Expiry"
                            (ngModelChange)="onChangeDate()"
                            #expiryDate="bsDatepicker" />
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-default" (click)="expiryDate.show()">
                                <i class="glyphicon glyphicon-calendar"></i>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label><span class="mandatory-field"></span>Title/Name </label>
            <input legacy-css name="CardName" type="text" class="form-control" [(ngModel)]="card.CardName" maxlength="100" required />
        </div>
        <div class="form-group">
            <label> Details/Notes </label>
            <textarea legacy-css name="CardDetails" class="form-control" style="height: 150px" [(ngModel)]="card.CardDetails">{{
                card.CardDetails
            }}</textarea>
        </div>
        <div class="row" *ngIf="card.Expiry">
            <div class="col-xs-12">
                <div class="alert alert-block alert-info">A reminder will be automatically added for this card's expiry date.</div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
        <button type="button" class="btn-bx-primary ml-2" (click)="ok()" [disabled]="!detailsForm.valid">Save &amp; Close</button>
    </div>
</form>
